import presentationService from '../service/presentation.service.js';

export class PresentationGroup {
    constructor() {
        this.playlistId = "";
        this.presentations = [];
    }   
    addPresentation(presentation) {
        this.presentations.push(presentation);
    }
    addPresentationAtIndex(index, presentation) {
        this.presentations.splice(index, 0, presentation);
    }
    removePresentation(presentationId) {
        this.presentations = this.presentations.filter(presentation => presentation.id !== presentationId);
    }
    removePresentationAtIndex(index) {
        this.presentations.splice(index, 1);
    }
    getPresentation(index) {
        return this.presentations[index];
    }
}

export class Presentation {
    constructor(data = {}) {
        this.songId = data.songId || "";
        this.title = data.title || "";
        this.lines = data.lines || [];
        this.pages = data.pages || [];
        this.groupSize = data.groupSize || 2;
        this.background = data.background || null;
        this.backgroundType = data.backgroundType || null;
        this.backgroundTransition = data.backgroundTransition || 'fade';
    }
    addPage(page) {
        this.pages.push(page);
        this.lines.push(page);
    }
    addPageAtIndex(index, page) {
        this.lines.splice(index, 0, page);
        this.pages.splice(index, 0, page);
    }
    removePage(pageId) {
        this.pages = this.pages.filter(page => page.id !== pageId);
    }
    removePageAtIndex(index) {
        this.pages.splice(index, 1);
    }
    movePageAtIndex(oldIndex, newIndex) {
        const moved = this.pages.splice(oldIndex, 1)[0]
        this.pages.splice(newIndex, 0, moved)
    }

    groupPages(groupSize, addEmptyPage = true) {
        if (this.pages.length > 0) {
            console.log("Pages already grouped");
            return;
        }
        this.pages = presentationService.groupArray(this.lines, groupSize).map(page => ({...page, editable: page.editable || true}));
        if (addEmptyPage) {
            this.pages.unshift({content: "", title: "", subtitle: "", 
                header: "", background: "", effect: true, editable: false, videoId: null});
        }
    }
}